import React from 'react';
import styles from './table.css';
import cx from 'classnames';
import { TableContext } from './table-context';

export interface TableProps {
  /** One or more table row components */
  children: React.ReactNode;
  /** The number of columns in your table */
  columns: number;
  /** A custom class name */
  className?: string;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * Table component
 *
 * @param {TableProps} param
 *
 * @returns JSX.ELEMENT
 */
export const Table = ({ columns, children, className, 'data-testid': dataTestId }: TableProps) => {
  const composedClass = cx(styles.table, className);
  return (
    <TableContext.Provider value={{ columns }}>
      <div className={composedClass} data-testid={dataTestId}>
        {children}
      </div>
    </TableContext.Provider>
  );
};

export default Table;
